export const blockIconsNotificationDriveEta = (
	<span className='material-symbols-outlined'>drive_eta</span>
);
